export const getFractionPart = number => (number.includes('.') ? number.split('.')[1] : '0');
